import loadable from '@loadable/component';

export const ErrorLoadable = loadable(() => import('./Error'), {
  fallback: null, // @TODO Добавить фолбек
  ssr: false,
});
